import { useState, useEffect } from 'react';
import { BACKGROUND_THEMES, BackgroundThemeType, DEFAULT_BACKGROUND_THEME } from '../constants/backgroundThemes';

const THEME_KEY = 'calmi_background_theme';

export const useBackgroundTheme = () => {
  const [selectedTheme, setSelectedTheme] = useState<BackgroundThemeType>(() => {
    const saved = localStorage.getItem(THEME_KEY);
    return (saved as BackgroundThemeType) || DEFAULT_BACKGROUND_THEME;
  });

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === THEME_KEY) {
        setSelectedTheme((e.newValue as BackgroundThemeType) || DEFAULT_BACKGROUND_THEME);
      }
    };

    const handleCustomThemeChange = (e: CustomEvent) => {
      const newTheme = e.detail as BackgroundThemeType;
      if (newTheme && BACKGROUND_THEMES.some(t => t.id === newTheme)) {
        setSelectedTheme(newTheme);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('calmi-theme-change', handleCustomThemeChange as EventListener);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('calmi-theme-change', handleCustomThemeChange as EventListener);
    };
  }, []);

  const handleThemeSelect = (theme: BackgroundThemeType) => {
    setSelectedTheme(theme);
    localStorage.setItem(THEME_KEY, theme);
    window.dispatchEvent(new CustomEvent('calmi-theme-change', { detail: theme }));
  };

  const selectedThemeData = BACKGROUND_THEMES.find(t => t.id === selectedTheme) || BACKGROUND_THEMES[0];

  return {
    selectedTheme,
    setSelectedTheme: handleThemeSelect,
    selectedThemeData
  };
};
